jQuery(document).ready(function($) {
	jQuery('.open_popup a.button').on('click', function(e){
		e.preventDefault();
		jQuery('div#wc_readmore').show();
	});
	jQuery('a.close_popup').on('click', function(e){
		e.preventDefault();
		jQuery('div#wc_readmore').hide();
	});
	
    jQuery('.cru-2-col').each(function(){
        parentHeight = jQuery(this).height();
        jQuery(this).children('.image-column').height(parentHeight);
    });
    
    jQuery('a.scroll_to, .scroll_to a').on('click', function(e){
		e.preventDefault();
		jQuery('a.scroll_to').each(function(){
			jQuery(this).removeClass('active');
		});
		jQuery(this).addClass('active');
		var targ = jQuery(this).attr('href');
		if(targ == "#our-story" && jQuery(window).width() <= 782){
			targ = "#terrior_mobile";
		}
		if(jQuery(window).width() > 900){
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
		else{
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
	});

	jQuery('.image-column .slider').slick({
	    infinite: true,
	    dots: true,
	    speed: 500,
	    fade: true,
	    cssEase: 'linear',
	    autoplay: true,
  		autoplaySpeed: 5000,
  		prevArrow:"<i class='fa-solid fa-chevron-left'></i>",
      	nextArrow:"<i class='fa-solid fa-chevron-right'></i>"
	});
	
	var product_item_height = 0;
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		if(jQuery(this).height() > product_item_height){
			product_item_height = jQuery(this).height();
		}
	});
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		jQuery(this).height(product_item_height);
	});

	if(jQuery(window).width() <= 781){
		jQuery('.cru-featured-products').slick({
			infinite: true,
			dots: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: false
		});

		jQuery('.layout-grid .cru-product-slider').slick({
			infinite: true,
			dots: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: false
		});
	}

	jQuery('a.open_submenu').on('click', function(e){
		e.preventDefault();
		console.log('test');
		jQuery(this).siblings('ul.sub-menu').html();
		if(jQuery(this).hasClass('active')){
			jQuery(this).parent().removeClass('active');
			jQuery(this).removeClass('active');
		}
		else{
			jQuery(this).parent().addClass('active');
			jQuery(this).addClass('active');
		}
	});
	
});

jQuery('body').on('click', 'button.winepik-bocs-card', function(){
    if(jQuery(this).attr('data-bocs-id') == "646aaeb3-6779-4c47-b235-db8968685be6"){
        jQuery('.step--pack-size').addClass('setPack');
    }
    else{
        jQuery('.step--pack-size').removeClass('setPack');
    }
});

jQuery(function ($) {

    const observer = new MutationObserver(function () {

        const $packGrid = $('.winepik-section.winepik-step.step--pack-size');

        if ($packGrid.length) {

            console.log('Case size section loaded');

            // Run whatever you need here
            // example:
            if(jQuery('.winepik-bocs-card[data-bocs-id="ae8e3760-9d1b-4e3d-9f42-cccb5fefe981"]').hasClass('is-selected')){
        		jQuery('.step--pack-size').addClass('setPack');
        	}

            // Stop observing
        }

    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});